/**
 * Calculates the difference in milliseconds between two dates.
 *
 * @param {string|Date} requestDate - The date of the request. It can be a date string or a Date object.
 * @param {string|Date} requestToMatchDate - The date of the request to match. It can be a date string or a Date object.
 * @returns {number|null} The difference in milliseconds between the two dates, or null if either date is not provided or not valid.
 */
export default function getResponseTimeDifferenceInMs(requestDate, requestToMatchDate) {
	if (!requestDate || !requestToMatchDate) return null
	const requestDateObj = new Date(requestDate)
	const requestToMatchDateObj = new Date(requestToMatchDate)
	if (isNaN(requestDateObj) || isNaN(requestToMatchDateObj)) return null
	return requestDateObj - requestToMatchDateObj
}
